import { T_CmsErrorVariable } from "../features/Features_Cms/CmsErrorVariables.Types";
import { T_CmsPageVariables } from "../features/Features_Cms/CmsPageVariable.Types";
import { useAppSelector } from "../redux-store/CustomReduxHooks";

const useCmsPageVariables = (cmsType: string) => {
  const cmsData = useAppSelector((st) => st.CmsSlice.CmsPageVariableData || []);

  let pageVariableData: T_CmsPageVariables | null = null;
  if (cmsData) {
    let data = cmsData.find((i) => i.attributes.cmsType === cmsType) ?? null;

    // Set the final description if found
    if (data) {
      pageVariableData = data;
    }
  }

  return pageVariableData;
};

export const useCmsPageErrorVariables = (cmsErrorCode: string) => {
  const cmsData = useAppSelector(
    (st) => st.CmsSlice.CmsErrorVariablesData || []
  );
  let pageErrorVariableData: T_CmsErrorVariable | null = null;
  if (cmsData) {
    let data =
      cmsData.find((i) => i.attributes.errorCode === cmsErrorCode) ?? null;

    // Set the final description if found
    if (data) {
      pageErrorVariableData = data;
    }
  }

  return pageErrorVariableData;
};

export const useCmsNudgeText = (lob?: string) => {
  const cmsData = useAppSelector((st) => st.CmsSlice.CmsPageVariableData || []);

  let pageVariableData: T_CmsPageVariables | null = null;
  if (cmsData) {
    let data =
      cmsData.find(
        (i) =>
          i.attributes.cmsType === "nudge" &&
          i.attributes.pageReference === window.location.pathname &&
          i.attributes.lobId === lob
      ) ?? null;

    // Set the final description if found
    if (data) {
      pageVariableData = data;
    }
  }

  return pageVariableData;
};

export default useCmsPageVariables;
